import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "edit-form"
}
const _hoisted_2 = ["initial-values"]
const _hoisted_3 = { class: "field flex flex-column gap-2 align-items-start" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Name", -1)
const _hoisted_5 = {
  id: "fullName-help",
  class: "p-error"
}
const _hoisted_6 = { class: "field flex flex-column gap-2 align-items-start" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "position" }, "Position", -1)
const _hoisted_8 = {
  id: "fullName-help",
  class: "p-error"
}
const _hoisted_9 = { class: "cta-section flex flex-row gap-2 justify-content-end" }
const _hoisted_10 = {
  key: 1,
  class: "create-pending"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, "Editing channel group...", -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 2,
  class: "create-complete"
}
const _hoisted_14 = { class: "cta-section flex flex-row gap-3 justify-content-end" }

import { watch, ref, onMounted } from 'vue';
import { useGuildStore } from '@/stores/GuildStore';
import { useApiStatusStore } from '@/stores/ApiStatusStore';
import { useDialogStore } from '@/stores/DialogStore';
import { useForm, configure, GenericObject } from 'vee-validate';
import * as yup from 'yup';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import { ChannelGroup, EditChannelGroupPayload } from '@/models/channel-list.model';


export default /*#__PURE__*/_defineComponent({
  __name: 'GuildChannelGroupEdit',
  props: {
    props: {}
  },
  setup(__props: any) {

const guildStore = useGuildStore();
const apiStatusStore = useApiStatusStore();
const dialogStore = useDialogStore();

const props = __props;

const formValues = ref({
  name: props.props.group.name,
  position: props.props.group.position
});

const schema = yup.object({
  name: yup.string().min(4).required(),
  position: yup.number(),
});

const { defineField, handleSubmit, setValues, errors } = useForm({
  validationSchema: schema,
});

const [name] = defineField('name');
const [position] = defineField('position');

configure({
  validateOnBlur: true,
  validateOnChange: false,
  validateOnInput: false,
  validateOnModelUpdate: false
})

onMounted(() => {
  setValues(formValues.value);
});

const onSubmit = handleSubmit(async (values: GenericObject) => {
  if(guildStore.guild){
    const body: EditChannelGroupPayload = {
      guildId: guildStore.guild.id,
      channelGroupId: props.props.group.id,
      name: values.name,
      position: values.position,
    }
    await guildStore.updateChannelGroup(body);
  } else {
    console.error('Cannot edit channel group, guild is undefined');
  }
});

watch(() => apiStatusStore.requestFulfilled('put_channel-group'), (newValue) => {
  if (newValue) {
    useDialogStore().changeHeader('Channel group succesfully edited')
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(apiStatusStore).requests.get('put_channel-group'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("form", {
            onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args)), ["prevent"])),
            "initial-values": formValues.value
          }, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(_unref(InputText), {
                modelValue: _unref(name),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(name) ? (name).value = $event : null)),
                id: "name"
              }, null, 8, ["modelValue"]),
              _createElementVNode("small", _hoisted_5, _toDisplayString(_unref(errors).name), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_unref(InputText), {
                modelValue: _unref(position),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(position) ? (position).value = $event : null)),
                id: "position",
                type: "number"
              }, null, 8, ["modelValue"]),
              _createElementVNode("small", _hoisted_8, _toDisplayString(_unref(errors).position), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_unref(Button), {
                label: "Cancel",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(dialogStore).closeDialog()))
              }),
              _createVNode(_unref(Button), {
                type: "submit",
                label: "Edit",
                disabled: _unref(apiStatusStore).requestPending('put_channel-group')
              }, null, 8, ["disabled"])
            ])
          ], 40, _hoisted_2)
        ]))
      : _createCommentVNode("", true),
    (_unref(apiStatusStore).requestPending('put_channel-group'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
      : _createCommentVNode("", true),
    (_unref(apiStatusStore).requestFulfilled('put_channel-group'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_unref(Button), {
              label: "Close",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(dialogStore).closeDialog()))
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})